module.exports = (error, errorExists, errorNotExists) => {

  if (error) {

    errorExists(error)

  } else {

    errorNotExists()

  }

}



// WEBPACK FOOTER //
// ../node_modules/vqua/lib/helpers/handleError.js